"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteObjects = void 0;
const aws_client_utils_1 = require("@aws-amplify/core/internals/aws-client-utils");
const utils_1 = require("@aws-amplify/core/internals/utils");
const composers_1 = require("@aws-amplify/core/internals/aws-client-utils/composers");
const utils_2 = require("../utils");
const generateDeleteObjectsXml_1 = require("../../generateDeleteObjectsXml");
const md5_1 = require("../../md5");
const base_1 = require("./base");
const deleteObjectsSerializer = async (input, endpoint) => {
    const url = new utils_1.AmplifyUrl(endpoint.url.toString());
    (0, utils_2.validateS3RequiredParameter)(!!input.Delete, 'Delete');
    url.pathname = '/';
    url.search = new utils_1.AmplifyUrlSearchParams({
        delete: '',
    }).toString();
    const body = (0, generateDeleteObjectsXml_1.generateDeleteObjectsXml)(input.Delete.Objects, input.Delete.Quiet ?? false);
    const contentMd5 = input.ContentMD5 ?? (await (0, md5_1.calculateContentMd5)(body));
    const headers = (0, utils_2.assignStringVariables)({
        'x-amz-expected-bucket-owner': input.ExpectedBucketOwner,
        'content-type': 'application/xml',
        'content-md5': contentMd5,
    });
    const request = {
        method: 'POST',
        headers,
        url,
        body,
    };
    return request;
};
const deleteObjectsDeserializer = async (response) => {
    if (response.statusCode >= 300) {
        const error = await (0, base_1.parseXmlError)(response);
        throw (0, utils_2.buildStorageServiceError)(error);
    }
    const text = await response.body.text();
    const deleted = [];
    const errors = [];
    const deletedMatches = text.matchAll(/<Deleted>[\s\S]*?<\/Deleted>/g);
    for (const match of deletedMatches) {
        const keyMatch = match[0].match(/<Key>(.*?)<\/Key>/);
        if (keyMatch) {
            deleted.push({ Key: keyMatch[1] });
        }
    }
    const errorMatches = text.matchAll(/<Error>[\s\S]*?<\/Error>/g);
    for (const match of errorMatches) {
        const keyMatch = match[0].match(/<Key>(.*?)<\/Key>/);
        const codeMatch = match[0].match(/<Code>(.*?)<\/Code>/);
        const messageMatch = match[0].match(/<Message>(.*?)<\/Message>/);
        errors.push({
            Key: keyMatch?.[1],
            Code: codeMatch?.[1],
            Message: messageMatch?.[1],
        });
    }
    const result = {
        Deleted: deleted,
        Errors: errors,
        $metadata: (0, aws_client_utils_1.parseMetadata)(response),
    };
    return result;
};
exports.deleteObjects = (0, composers_1.composeServiceApi)(utils_2.s3TransferHandler, deleteObjectsSerializer, deleteObjectsDeserializer, { ...base_1.defaultConfig, responseType: 'text' });
